const prdUnits = [
    {
      address: {
        cep: '05455-001',
        city: 'São Paulo',
        complement: '',
        name: 'Av. São Gualter',
        neighborhood: 'Vila Ida',
        number: '766',
        state: 'SP',
      },
      id: '6f440ab5-03f3-44cf-8165-1049662c3a93',
      name: 'CLÍNICA EINSTEIN ALTO DE PINHEIROS',
    },
    {
      address: {
        cep: '03342-000',
        city: 'São Paulo',
        complement: '2º andar ',
        name: 'Avenida Regente Feijó',
        neighborhood: 'Vila Regente Feijó',
        number: '1425',
        state: 'SP',
      },
      id: 'a43d49c8-c52f-4ee2-a29d-784802beed4a',
      name: 'CLÍNICA EINSTEIN ANÁLIA FRANCO',
    },
    {
      address: {
        cep: '04794-000',
        city: 'São Paulo',
        complement: 'Torre Jequitimar',
        name: 'Av. das Nações Unidas',
        neighborhood: 'Vila Gertrudes',
        number: '14401',
        state: 'SP',
      },
      id: '1dfc9d11-c053-456d-a240-43d933dd7346',
      name: 'CLÍNICA EINSTEIN PARQUE DA CIDADE',
    },
    {
      address: {
        cep: '04501-000',
        city: 'São Paulo',
        complement: '',
        name: 'Av. República do Líbano',
        neighborhood: 'Ibirapuera',
        number: '315',
        state: 'SP',
      },
      id: '531cff9b-ab20-4a77-a8b2-26bf72af6878',
      name: 'CLÍNICA EINSTEIN PARQUE IBIRAPUERA',
    },
    {
      address: {
        cep: '02022-011',
        city: 'São Paulo',
        complement: '',
        name: 'Av. Braz Leme',
        neighborhood: 'Santana',
        number: '3265',
        state: 'SP',
      },
      id: 'b19738f9-3d5f-48f4-a59d-9faa770136dd',
      name: 'CLÍNICA EINSTEIN SANTANA',
    },
    {
      address: {
        cep: '18047-710',
        city: 'Sorocaba',
        complement: '',
        name: 'Rua Manoel Soares Leitão',
        neighborhood: 'Parque Campolim',
        number: '21',
        state: 'SP',
      },
      id: '02dd4284-b8d8-407a-9b68-0d75885ab3fc',
      name: 'SOROCABA ',
    },
    {
      address: {
        cep: '06455-010',
        city: 'São Paulo',
        complement: '',
        name: 'Av. Juruá',
        neighborhood: 'Barueri',
        number: '706',
        state: 'SP',
      },
      id: '228a10cb-6cab-4538-9621-f0ce51148566',
      name: 'UNIDADE EINSTEIN ALPHAVILLE',
    },
    {
      address: {
        cep: '04260-000',
        city: 'São Paulo',
        complement: '',
        name: 'Av. Doutor Ricardo Jafet',
        neighborhood: 'Ipiranga',
        number: '1600',
        state: 'SP',
      },
      id: 'd0bafbb8-c911-4131-bab3-f5ec133e0745',
      name: 'UNIDADE EINSTEIN CHÁCARA KLABIN',
    },
    {
      address: {
        cep: '74150-030',
        city: 'Goiânia',
        complement: '',
        name: 'Av. Portugal',
        neighborhood: 'Setor Marista',
        number: '1148',
        state: 'GO',
      },
      id: '7c47fb80-b23a-4fac-9a64-ea1fb6882584',
      name: 'UNIDADE EINSTEIN GOIÂNIA',
    },
    {
      address: {
        cep: '04501-000',
        city: 'São Paulo',
        complement: '',
        name: 'Av. República do Líbano',
        neighborhood: 'Ibirapuera',
        number: '501',
        state: 'SP',
      },
      id: 'daa51511-308b-4999-8b0e-5d63cd8c012f',
      name: 'UNIDADE EINSTEIN IBIRAPUERA',
    },
    {
      address: {
        cep: '01431-000',
        city: 'São Paulo',
        complement: '',
        name: 'Av. Brasil',
        neighborhood: 'Jardim América',
        number: '1085',
        state: 'SP',
      },
      id: '12127041-7513-4498-9f4b-89fe01ba9dec',
      name: 'UNIDADE EINSTEIN JARDINS',
    },
    {
      address: {
        cep: '05652-900',
        city: 'São Paulo',
        complement: '',
        name: 'Av. Albert Einstein',
        neighborhood: 'Jardim Leonor',
        number: '627',
        state: 'SP',
      },
      id: 'e56714b6-9b98-4bf1-91c6-179175738da1',
      name: 'UNIDADE EINSTEIN MORUMBI',
    },
    {
      address: {
        cep: '05017-020',
        city: 'São Paulo',
        complement: '',
        name: 'Rua Apiacás',
        neighborhood: 'Perdizes',
        number: '85',
        state: 'SP',
      },
      id: '96251a0a-1d4e-4f7c-a6f3-ff4689545b36',
      name: 'UNIDADE EINSTEIN PERDIZES',
    },
    {
      address: {
        cep: '04020-040',
        city: 'São Paulo',
        complement: '',
        name: 'Rua Madre Cabrini',
        neighborhood: 'Vila Mariana',
        number: '462',
        state: 'SP',
      },
      id: 'd0caa09f-16b6-4d98-ac74-c81a4ac98e7c',
      name: 'UNIDADE EINSTEIN VILA MARIANA ',
    },
  ];

  export const getUnitAddress = (id) => {
    const unit = prdUnits.find((u) => u.id === id);
    if (!unit) {
      return '';
    }
    return `${unit.address.name && unit.address.name !== '' ? unit.address.name : ''} ${
      unit.address.number && unit.address.number !== '' ? unit.address.number : ''
    }, ${
      unit.address.neighborhood && unit.address.neighborhood !== '' ? unit.address.neighborhood : ''
    }, ${unit.address.city && unit.address.city !== '' ? unit.address.city : ''} - ${
      unit.address.state && unit.address.state !== '' ? unit.address.state : ''
    }`;
  };